import * as React from "react";

// Stores
import { ActivityStore } from "stores";

// Layout
import { Grid } from "@material-ui/core";
import { Observer } from "mobx-react-lite";
import {
    CardTypeButtons,
    FontSizeButtons,
    worksheetOptionsBackgroundStyle,
} from "components/activities/CommonActivityOptions";
import { CardType } from "models/customLists/CategoryItem";
import { NumberOfWorksheetColumns } from "../WorksheetHelper";
import { WorksheetOptions } from "../WorksheetScene";
import SimpleCheckbox from "components/SimpleCheckbox";
import { strings } from "core/localizedStrings";

export interface WordScrambleWorksheetOptions extends WorksheetOptions {
    cardType: CardType;
    numberOfColumns: NumberOfWorksheetColumns;
    fontSize: number;
}

export const defaultWordScrambleWorksheetOptions: WordScrambleWorksheetOptions = {
    cardType: CardType.IMAGE_ONLY,
    numberOfColumns: NumberOfWorksheetColumns.ONE,
    fontSize: 42,
};

interface WordScrambleWorksheetOptionsProps extends React.Props<any> {
    activityStore: ActivityStore;
}

const WordScrambleWorksheetOptions = (props: WordScrambleWorksheetOptionsProps) => {
    const handleCardTypeChanged = (cardType: CardType) => {
        props.activityStore.activityOptions.wordScrambleWorksheetOptions.cardType = cardType;
        props.activityStore.updateOptions();
    };

    const handleTwoColumnsCheckboxChanged = (value: boolean) => {
        props.activityStore.activityOptions.wordScrambleWorksheetOptions.numberOfColumns = value
            ? NumberOfWorksheetColumns.TWO
            : NumberOfWorksheetColumns.ONE;
        props.activityStore.updateOptions();
    };

    const handleFontSizeDecremented = () => {
        const MIN_FONT_SIZE = 30;
        props.activityStore.activityOptions.wordScrambleWorksheetOptions.fontSize *= 0.9;
        if (props.activityStore.activityOptions.wordScrambleWorksheetOptions.fontSize < MIN_FONT_SIZE) {
            props.activityStore.activityOptions.wordScrambleWorksheetOptions.fontSize = MIN_FONT_SIZE;
        }
    };

    const handleFontSizeIncremented = () => {
        const MAX_FONT_SIZE = 56;
        props.activityStore.activityOptions.wordScrambleWorksheetOptions.fontSize *= 1.1;
        if (props.activityStore.activityOptions.wordScrambleWorksheetOptions.fontSize > MAX_FONT_SIZE) {
            props.activityStore.activityOptions.wordScrambleWorksheetOptions.fontSize = MAX_FONT_SIZE;
        }
    };

    return (
        <Observer
            render={() => (
                <>
                    <CardTypeButtons
                        activityStore={props.activityStore}
                        onCardTypeChanged={handleCardTypeChanged}
                        selectedType={props.activityStore.activityOptions.wordScrambleWorksheetOptions.cardType}
                    />
                    <Grid
                        container
                        direction="column"
                        justify="center"
                        alignItems="center"
                        style={worksheetOptionsBackgroundStyle}
                    >
                        <Grid container justify="center">
                            <Grid item>
                                <SimpleCheckbox
                                    label={strings.twoColumns}
                                    isChecked={
                                        props.activityStore.activityOptions.wordScrambleWorksheetOptions
                                            .numberOfColumns === NumberOfWorksheetColumns.TWO
                                    }
                                    onChange={handleTwoColumnsCheckboxChanged}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <FontSizeButtons
                        onFontSizeDecremented={handleFontSizeDecremented}
                        onFontSizeIncremented={handleFontSizeIncremented}
                    />
                </>
            )}
        />
    );
};

export default WordScrambleWorksheetOptions;
